<template>
  <div v-loading="isLoading">
    <el-button
      type="text"
      class="back-button"
      icon="el-icon-arrow-left"
      @click="$router.go(-1)"
    ></el-button>
    <div class="buy-ticket-wrapper">
      <h3 class="page-title">填写发票信息</h3>
      <div class="hightlight-tip">
        温馨提示：<br />
        1、一经提交无法修改，请确认填写无误后再提交，若后续有修改可联系工作人员；<br />
        2、发票预计于案例会活动（4月18日）结束后的2周内为您开出，请耐心等候；<br />
        3、开票内容为【会务培训费/营销策划费】，默认开“会务培训费”，若指定内容，请在发票页备注中明确。
      </div>
      <el-form
        ref="form"
        :rules="rules"
        :model="formData"
        :disabled="isDisabled"
      >
        <div>
          <el-form-item prop="type" class="company-rise" label="发票类型">
            <el-radio v-model="formData.type" label="0">普票</el-radio>
            <el-radio v-model="formData.type" label="1">专票</el-radio>
          </el-form-item>

          <el-form-item prop="companyName" label="公司名称">
            <el-input
              v-model="formData.companyName"
              class="weui-input"
              placeholder="请输入公司名称"
            />
          </el-form-item>

          <el-form-item prop="rid" label="税号">
            <el-input
              v-model="formData.rid"
              class="weui-input"
              placeholder="请输入公司税号"
            />
          </el-form-item>

          <el-form-item prop="address" label="公司地址">
            <el-input
              v-model="formData.address"
              class="weui-input"
              placeholder="请输入公司地址"
            />
          </el-form-item>

          <el-form-item prop="bankName" label="开户行">
            <el-input
              v-model="formData.bankName"
              class="weui-input"
              placeholder="请输入开户行"
            />
          </el-form-item>

          <el-form-item prop="bankId" label="银行账号">
            <el-input
              v-model="formData.bankId"
              class="weui-input"
              placeholder="请输入银行账号"
            />
          </el-form-item>

          <el-form-item prop="mobile" label="联系电话">
            <el-input
              v-model="formData.mobile"
              class="weui-input"
              placeholder="请输入联系电话"
            />
          </el-form-item>

          <el-form-item prop="email" label="电子发票接收邮箱">
            <el-input
              v-model="formData.email"
              class="weui-input"
              placeholder="请输入电子发票接收邮箱"
            />
          </el-form-item>

          <el-form-item prop="remark" label="备注">
            <el-input
              type="textarea"
              v-model="formData.remark"
              class="weui-input"
              placeholder="请输入备注"
            />
          </el-form-item>
        </div>

        <div v-if="!isDisabled" @click="submitForm" class="submit-button">
          <div>
            <span>提交</span>
          </div>
        </div>
      </el-form>
    </div>
    <router-view @resove-url="copyUrl = $event" />
  </div>
</template>

<script>
import { addInvoice, getInvoice } from "@/api/index.js";

export default {
  name: "Invoice",
  data() {
    return {
      isLoading: false,
      formData: {
        type: "0",
        companyName: "",
        rid: "",
        address: "",
        mobile: "",
        bankName: "",
        bankId: "",
        remark: "",
        email: ""
      },
      rules: {
        type: [{ required: true, message: "请选择发票类型" }],
        companyName: [{ required: true, message: "公司名称必填" }],
        rid: [{ required: true, message: "税号必填" }],
        mobile: [{ required: true, message: "联系电话必填" }],
        email: [{ required: true, message: "电子发票接收邮箱必填" }]
      },
      orderId: "",
      invoice: {},
      isDisabled: false
    };
  },
  created() {
    this.orderId = this.$route.params.id;

    console.log("orderId: " + this.orderId);

    getInvoice(this.orderId)
      .then(({ code, data }) => {
        console.log("getInvoice response:", { code, data });
        if (code === 200) {
          if (data) {
            this.invoice = data; // 假设返回的是一个对象
            this.formData = {
              type: this.invoice.type || "0",
              companyName: this.invoice.name || "",
              rid: this.invoice.taxNum || "",
              address: this.invoice.resAddr || "",
              mobile: this.invoice.resTel || "",
              bankName: this.invoice.bankName || "",
              bankId: this.invoice.bankAccount || "",
              remark: this.invoice.content || "",
              email: this.invoice.email || ""
            };
            this.isDisabled = true; // 设置为不可编辑
          }
        } else {
          console.error("Failed to get invoice:", code, data);
        }
      })
      .catch(error => {
        console.error("Error fetching invoice:", error);
      });
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          addInvoice({
            type: this.formData.type,
            name: this.formData.companyName,
            taxNum: this.formData.rid,
            resAddr: this.formData.address,
            resTel: this.formData.mobile,
            bankName: this.formData.bankName,
            bankAccount: this.formData.bankId,
            content: this.formData.remark,
            orderId: this.$route.params.id,
            email: this.formData.email,
            money: this.$route.params.totalPrice
          })
            .then(({ code }) => {
              if (code === 200) {
                this.$message.success("发票申请已提交");
                this.$router.replace({
                  name: "Mine"
                });
              } else {
                this.$message.error("发票申请异常");
              }
            })
            .catch(error => {
              console.error("Error adding invoice:", error);
            });
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.buy-ticket-wrapper {
  padding: 10px 15px 180px 15px;
  box-sizing: border-box;
  background-color: #f7f7f7;
  /deep/ .el-form-item__label {
    font-size: 14px;
  }
  .page-title {
    font-size: 20px;
    text-align: center;
    padding: 10px 0 10px;
  }
  .company-rise {
    /deep/ .el-form-item__content {
      line-height: 24px;
    }
  }
}

.tip-text {
  font-size: 11px;
  color: #aaaaaa;
  text-align: center;
}

.hightlight-tip {
  font-size: 14px;
  color: #ff0000;
  background-color: #f7f7f7;
  text-align: left;
}
</style>
